import { render, staticRenderFns } from "./FormAddContent.vue?vue&type=template&id=267ac4a0&scoped=true&"
import script from "./FormAddContent.vue?vue&type=script&lang=js&"
export * from "./FormAddContent.vue?vue&type=script&lang=js&"
import style0 from "./FormAddContent.vue?vue&type=style&index=0&id=267ac4a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267ac4a0",
  null
  
)

export default component.exports